/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const microphone_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.5 17.867V23M4 8.333v2.51a7.133 7.133 0 0 0 2.27 5.023 7.461 7.461 0 0 0 5.23 2 7.461 7.461 0 0 0 5.23-2A7.132 7.132 0 0 0 19 10.842V8.333M11.5 23h4m-4 0h-4m4-22C13.985 1 16 2.97 16 5.4v5.133c0 2.43-2.015 4.4-4.5 4.4s-4.5-1.97-4.5-4.4V5.4C7 2.97 9.015 1 11.5 1Z"
    />
  </svg>
)
export default microphone_medium
